document.addEventListener('DOMContentLoaded', function() {
  const track = document.querySelector('.carousel-track');
  const items = document.querySelectorAll('.carousel-item');
  const prevButton = document.querySelector('.carousel-btn.prev');
  const nextButton = document.querySelector('.carousel-btn.next');
  let currentIndex = 0;
  let itemWidth;

  // Function to update item width and track position
  function updateCarousel() {
    itemWidth = items[0].clientWidth; // Recalculate the width dynamically
    track.style.transform = `translateX(-${currentIndex * itemWidth}px)`;

    // Hide prev/next buttons if not needed
    if (items.length <= 1) {
      prevButton.style.display = 'none';
      nextButton.style.display = 'none';
    } else {
      prevButton.style.display = 'block';
      nextButton.style.display = 'block';
    }
  }

  // Move to next slide
  nextButton.addEventListener('click', function() {
    if (currentIndex < items.length - 1) { // Adjust to allow for the last item
      currentIndex++;
      updateCarousel();
    }
  });

  // Move to previous slide
  prevButton.addEventListener('click', function() {
    if (currentIndex > 0) {
      currentIndex--;
      updateCarousel();
    }
  });

  // Prevent overscrolling when there are fewer items than needed
  function handleEdgeCases() {
    if (items.length <= 2 && window.innerWidth <= 768) {
      currentIndex = 0; // Reset the index for mobile if fewer than 3 items
    }
    updateCarousel();
  }

  // Initial load and window resize events
  window.addEventListener('load', handleEdgeCases);
  window.addEventListener('resize', handleEdgeCases);
});
